import { connect } from 'react-redux';
import React, {Component} from 'react';
import { USER_POST_BET } from '../../../../constants/action-types';
import { precisionRound } from '../../../../utils';

class EventTeams extends Component {

    render() {
        return (
        <div className={'event-details-top' + (this.props.showPoolDetails ? ' poolDetails' : '')}>
            {this.props.event.totalBetsCount !== 0 && (!this.props.event.userPick) ? 
                !this.props.showPoolDetails ? 
                    (<div className='event-progress'>
                        <div data-team='1' style={{right: `${100 - ((this.props.event.bets_for_one / this.props.event.totalBetsCount) * 100)}%`, backgroundColor: this.props.event.team_one_colour}} data-progress={(this.props.event.bets_for_one / this.props.event.totalBetsCount) * 100}></div>
                        <div data-team='2' style={{left: `${((this.props.event.bets_for_one / this.props.event.totalBetsCount) * 100)}%`, backgroundColor: this.props.event.team_two_colour}} data-progress={(this.props.event.bets_for_two / this.props.event.totalBetsCount) * 100}></div>
                    </div>)
                : (
                    <div className='event-progress' style={{height: '25px', background: `linear-gradient(90deg, ${this.props.event.team_one_colour} ${((this.props.event.bets_for_one / this.props.event.totalBetsCount) * 100)}%, ${this.props.event.team_two_colour})`}}></div>
                ) : (null)}
            <div className='event-bet-count-wrap'>
                {!this.props.event.userPick ? (
                    <small>{this.props.event.totalBetsCount} bet{this.props.event.totalBetsCount === 1 ? '' : 's'}</small>
                ) : (
                    <small style={{transform: `translateY(-5px)`}}>You chose {this.props.event.userPick}</small>
                )}
            </div>
            
            <div className='event-teams'>
                <div className='event-odds-wrap'>
                    {!this.props.event.userPick ? (
                        <div className='event-odds'>
                            <small>vs</small>
                            {this.props.event.totalBetsCount !== 0 ? (
                                <div className='event-progress event-progress-circle'>
                                    <div className='event-circle-indicator-wrap'>
                                        <div className='event-odd-circle-indicator' style={{backgroundColor: this.props.event.team_one_colour}} data-team='1' data-odd={(this.props.event.bets_for_one / this.props.event.totalBetsCount) * 100}></div>
                                    </div>
                                    <div className='event-odd-circle-indicator' style={{backgroundColor: this.props.event.team_two_colour}} data-team='2' data-odd={(this.props.event.bets_for_two / this.props.event.totalBetsCount) * 100}>
                                    </div>
                                </div>
                            ) : (null)}
                        </div>
                    ) : (null)}
                </div>
                <div className='event-team'>
                    <div className='event-team-details-wrap'>
                        <div className='event-team-details'>
                            <div className={`flag flag-icon flag-icon-${(this.props.event.team_one_iso || '').toLowerCase()}`}></div>
                            <h5 className='mvu-title'>{this.props.event.team_one_name}</h5>
                            {this.props.event.totalBetsCount !== 0 && (!this.props.event.userPick) ? 
                                <small>{precisionRound((this.props.event.bets_for_one / this.props.event.totalBetsCount) * 100, 0)}% of bets</small>
                            : (null)}
                        </div>
                    </div>
                    {this.props.showPoolDetails ? (
                        <div className='event-pool-details'>
                            <div className='event-pool-detail'>
                                <small>{this.props.event.bets_for_one} bets for</small>
                            </div>
                            <div className='event-pool-detail'>
                                <small>winning bet earns {precisionRound((this.props.event.bets_for_two + this.props.event.bets_for_one + (this.props.event.bets_for_draw == undefined || this.props.event.bets_for_draw == null? 0 : this.props.event.bets_for_draw))/this.props.event.bets_for_one, 2)} bounty points</small>
                            </div>
                        </div>
                    ) : null}
                </div>
                <div className='event-team'>
                    <div className='event-team-details-wrap'>
                        <div className='event-team-details'>
                            <div className={`flag flag-icon flag-icon-${(this.props.event.team_two_iso || '').toLowerCase()}`}></div>
                            <h5 className='mvu-title'>{this.props.event.team_two_name}</h5>
                            {this.props.event.totalBetsCount !== 0 && (!this.props.event.userPick) ? 
                                <small>{precisionRound((this.props.event.bets_for_two / this.props.event.totalBetsCount) * 100, 0)}% of bets</small>
                            : (null)}
                        </div>
                    </div>
                    {this.props.showPoolDetails ? (
                        <div className='event-pool-details'>
                            <div className='event-pool-detail'>
                                <small>{this.props.event.bets_for_two} bets for</small>
                            </div>
                            <div className='event-pool-detail'>
                                <small>winning bet earns {precisionRound((this.props.event.bets_for_two + this.props.event.bets_for_one + (this.props.event.bets_for_draw == undefined || this.props.event.bets_for_draw == null ? 0 : this.props.event.bets_for_draw))/this.props.event.bets_for_two,2)} bounty points</small>
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
            {(this.props.showPoolDetails && (this.props.user.bets.map(b => b.eventId).indexOf(this.props.event.eventId) === -1)) ? (
                <div className='event-make-bet'>
                    <button onClick={this.props.makeBet.bind(this, { teamNum: 1, teamName: this.props.event.team_one_name, eventId: this.props.event.eventId})} className='primary' style={{border: `1px solid ${this.props.event.team_one_colour}`}}>
                        <div className='flex'>
                            <small>Bet on {this.props.event.team_one_name}</small>
                        </div>
                    </button>
                    {/* <button onClick={this.props.makeBet.bind(this, { teamNum: 3, teamName: this.props.event.team_one_name, eventId: this.props.event.eventId})} className='primary' style={{border: `1px solid white`}}>
                        <div className='flex'>
                            <small>Bet on a draw</small>
                        </div>
                    </button> */}
                    <button onClick={this.props.makeBet.bind(this, { teamNum: 2, teamName: this.props.event.team_two_name, eventId: this.props.event.eventId})} className='primary' style={{border: `1px solid ${this.props.event.team_two_colour}`}}>
                        <div className='flex'>
                            <small>Bet on {this.props.event.team_two_name}</small>
                        </div>
                    </button>
                </div>
            ) : null}
        </div>)
    }
}

const mapStateToProps = (state) => state

const mapDispatchToProps = (dispatch) => ({
    makeBet: ({teamNum, teamName, eventId}) => dispatch({ type: USER_POST_BET, payload: { teamNum, teamName, eventId } }) 
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EventTeams)


// WEBPACK FOOTER //
// ./src/components/general/event/widgets/EventTeams.js